// api/loginApi.ts
import { setStorageItem } from "../utils/appStorage";

export const handleLogin = async (
  username: string,
  password: string
): Promise<boolean> => {
  const response = await fetch(`${process.env.REACT_APP_API_URL}login/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ username, password }),
  });

  if (!response.ok) {
    throw new Error("Login failed");
  }

  const data = await response.json();

  setStorageItem("accessToken", data.access);
  if (data.refresh) {
    setStorageItem("refreshToken", data.refresh);
  }

  return true;
};
